import React, {useState, useRef, useEffect} from 'react';
import {Button} from 'primereact/button';
import {FileUpload} from 'primereact/fileupload';
import {Dialog} from 'primereact/dialog';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import AudioPlayerComponent from 'components/common/AudioPlayerWithSpeed';
import 'react-h5-audio-player/lib/styles.css';
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {InputSwitch} from "primereact/inputswitch";
import {setAudioField} from "../../../../redux/actions/actionsAudio";
import {Divider} from "primereact/divider";
import {Toast} from 'primereact/toast';
import {activeInActiveAudioById, getTempUrlById, removeAudioById, moveAudioToGroupId} from "../../../../redux/api/apiAudio";
import {confirmDialog, ConfirmDialog} from "primereact/confirmdialog";
import {SET_USER_STATUS_SUCCESS} from "../../../../redux/types/typesUsersList";
import axios from "axios";
import {Dropdown} from "primereact/dropdown";

const AudioFilesComponent = (props: any) => {
    const [visible, setVisible] = useState(false);
    const [visiblePlayerId, setVisiblePlayerId] = useState<number | null>(null);
    const [currentAudioSrc, setCurrentAudioSrc] = useState<string | null>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const audioPlayerRef = useRef(null);
    const toast = useRef<Toast>(null);
    const dispatch = useAppDispatch();
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as any;
    const playerPermissions = checkPermissions(rolesVision, 'Player');
    const editType = useAppSelector(state => state.UsersReducer.editType);
    const archiveTableToggle = useAppSelector(state => state.AudioListReducer.archiveAudioTableToggle);
    const audioData = useAppSelector(state => state.AudioListReducer.audioData);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const audioUrl = useAppSelector(state => state.AudioListReducer.audioUrlById);
    const loading = useAppSelector(state => state.AudioListReducer.audioUrlLoading);
    const audioGroups = useAppSelector(state => state.AudioListReducer.audiosList);
    const [audioToDelete, setAudioToDelete] = useState<{ id?: number, fileName: string } | null>(null);
    const [playRequested, setPlayRequested] = useState(false);
    const [lastRequestedFileName, setLastRequestedFileName] = useState<string | null>(null);
    const errorFields = useAppSelector(state => state.AudioListReducer.errorFields);
    const [moveDialogVisible, setMoveDialogVisible] = useState(false);
    const [selectedTargetGroup, setSelectedTargetGroup] = useState<any | null>(null);
    const [audioToMove, setAudioToMove] = useState<any | null>(null);

    // const {
    //     visible: hasPlayerVisiblePermission,
    //     update: hasPlayerUpdatePermission,
    // } = playerPermissions;

    useEffect(() => {
        setCurrentAudioSrc(null);
        setVisiblePlayerId(null);
    }, []);

    useEffect(() => {
        if (
            playRequested &&
            audioUrl?.tempUrl &&
            audioUrl?.fileName === lastRequestedFileName
        ) {
            setCurrentAudioSrc(audioUrl.tempUrl);
            setVisiblePlayerId(audioUrl.fileName);
            setIsPlaying(false);
            setPlayRequested(false);
        }
    }, [audioUrl, playRequested, lastRequestedFileName]);

    useEffect(() => {
        return () => {
            props.audios.forEach((audio: any) => {
                if (audio.src && audio.src.startsWith('blob:')) {
                    try {
                        URL.revokeObjectURL(audio.src);
                    } catch (error) {
                        console.error('Ошибка при очистке blob URL:', error);
                    }
                }
            });

            if (currentAudioSrc && currentAudioSrc.startsWith('blob:')) {
                try {
                    URL.revokeObjectURL(currentAudioSrc);
                } catch (error) {
                    console.error('Ошибка при очистке текущего blob URL:', error);
                }
            }

            if (audioData?.audios) {
                audioData.audios.forEach((audio: any) => {
                    if (audio.audioTempUrl && audio.audioTempUrl.startsWith('blob:')) {
                        try {
                            URL.revokeObjectURL(audio.audioTempUrl);
                        } catch (error) {
                            console.error('Ошибка при очистке сохраненного blob URL:', error);
                        }
                    }
                });
            }
        };
    }, [props.audios, currentAudioSrc, audioData?.audios]);

    const onFilesSelect = (e: { files: any }) => {
        let selectedFiles = Array.from(e.files || []);

        const existingNames = new Set<string>();
        (audioData?.audios || []).forEach((audio: any) => {
            if (audio.audioFileName) {
                existingNames.add(audio.audioFileName);
            }
            if (audio.audioName) {
                existingNames.add(audio.audioName);
            }
        });
        const existingUploadNames = new Set<string>(props.audios.map((a: any) => a.name));

        const duplicated = selectedFiles.filter(
            (file: any) =>
                existingNames.has(file.name) ||
                existingUploadNames.has(file.name)
        );

        if (duplicated.length) {
            const names = duplicated.map((f: any) => f.name).join(', ');
            toast.current?.show({
                severity: 'warn',
                summary: 'Увага',
                detail: `Аудіо вже існує: ${names}`,
                life: 3000
            });
        }

        selectedFiles = selectedFiles.filter(
            (file: any) =>
                !existingNames.has(file.name) &&
                !existingUploadNames.has(file.name)
        );

        if (!selectedFiles.length) {
            return;
        }

        const newFilesMap: { [key: string]: File } = {};

        const newAudios = selectedFiles.map((file: any, index) => {
            newFilesMap[file.name] = file;

            const existing = props.audios.find((a: { name: string }) => a.name === file.name);
            return {
                file,
                src: URL.createObjectURL(file),
                name: file.name,
                order: existing?.order || props.audios.length + index + 1,
                isActive: true,
            };
        });

        const filtered = props.audios.filter((a: { name: string }) => !newAudios.find(n => n.name === a.name));
        const combined = [...filtered, ...newAudios].map((a, i) => ({
            ...a,
        }));

        props.setAudios(combined);

        if (props.setAudioFilesMap) {
            props.setAudioFilesMap((prev: { [key: string]: File }) => ({
                ...prev,
                ...newFilesMap,
            }));
        }
    };
    const toggleAudioIsActive = (identifier: number, value: boolean) => {
        const audioItem = audioData?.audios?.find((audio: any) =>
            audio.audioId === identifier || (!audio.audioId && audio.order === identifier)
        );

        if (!audioItem) return;

        if (audioItem.audioId && audioData?.groupId && jwtToken?.jwtToken) {
            dispatch(activeInActiveAudioById(audioItem.audioId, audioData.groupId, jwtToken.jwtToken));
        } else {
            const updatedAudios = audioData.audios.map((audio: any) => {
                const matchById = audio.audioId === identifier;
                const matchByOrder = !audio.audioId && audio.order === identifier;

                if (matchById || matchByOrder) {
                    return { ...audio, isActive: value };
                }
                return audio;
            });

            dispatch(setAudioField({
                section: 'audioData',
                fieldName: 'audios',
                value: updatedAudios
            }));
        }
    };

    const removeAudio = (audioId: number | undefined, fileName: string) => {
        if (audioId && audioData?.groupId && jwtToken?.jwtToken) {
            dispatch(removeAudioById(audioId, audioData.groupId, jwtToken.jwtToken));
        } else {
            const updatedAudios = audioData.audios
                .filter((audio: any) => audio.audioFileName !== fileName)
                .map((audio: any) => ({...audio}));

            dispatch(setAudioField({
                section: 'audioData',
                fieldName: 'audios',
                value: updatedAudios
            }));

            const updatedPropsAudios = props.audios.filter((audio: any) => audio.name !== fileName);
            props.setAudios(updatedPropsAudios);

            if (props.setAudioFilesMap) {
                props.setAudioFilesMap((prev: { [key: string]: File }) => {
                    const updated = {...prev};
                    delete updated[fileName];
                    return updated;
                });
            }
        }
    };

    const handlePlayAudio = async (rowData: any) => {
        setPlayRequested(true);
        setLastRequestedFileName(rowData.audioFileName);

        if (rowData.audioTempUrl) {
            setCurrentAudioSrc(rowData.audioTempUrl);
            setVisiblePlayerId(rowData.audioFileName);
            setPlayRequested(false);
            return;
        }

        dispatch(getTempUrlById(rowData?.audioId, jwtToken?.jwtToken));
    };


    const handleAudioError = (error: any) => {
        console.error('Ошибка аудио плеера:', error);
        toast.current?.show({
            severity: 'error',
            summary: 'Помилка',
            detail: 'Помилка відтворення аудіо файлу. Перевірте формат файлу.',
            life: 3000
        });
        setVisiblePlayerId(null);
        setCurrentAudioSrc(null);
        setIsPlaying(false);
    };

    const handleAudioPlay = () => {
        setIsPlaying(true);
    };

    const handleAudioPause = () => {
        setIsPlaying(false);
    };

    const handleAudioEnded = () => {
        setIsPlaying(false);
    };

    const copyAudioLink = (url: string) => {
        if (!url || url.startsWith('blob:')) return;
        const copyToClipboard = (text: string) => {
            const tempElement = document.createElement('textarea');
            tempElement.value = text;
            document.body.appendChild(tempElement);
            tempElement.select();
            document.execCommand('copy');
            document.body.removeChild(tempElement);
        };
        copyToClipboard(url);
        dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: 'Посилання аудіо скопійована в буфер обміну'}});
    };

    const downloadAudioFromUrl = async () => {
        if (!currentAudioSrc) return;
        const fileName = (typeof visiblePlayerId === 'string' ? visiblePlayerId : lastRequestedFileName) || 'audio.mp3';
        if (currentAudioSrc.startsWith('blob:')) {
            const link = document.createElement('a');
            link.href = currentAudioSrc;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return;
        }
        const responseUrl = await axios.get(currentAudioSrc, {
            responseType: 'blob',
            headers: { cache: 'no-store', 'Cache-Control': 'no-cache' }
        });
        const blob = new Blob([responseUrl.data], {type: responseUrl.headers['content-type']});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const emptyTemplate = () => (
        <div className="flex align-items-center flex-column">
            <i className="pi pi-file-plus mt-3 p-5" style={{fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)'}}></i>
            <span style={{fontSize: '1.8em', color: 'white'}} className="my-3 font-bold">
                Завантажити файл
            </span>
            <span style={{fontSize: '1.2em', color: 'var(--text-color-secondary)'}} className=" font-bold">
                Перетягніть або виберіть файл
            </span>
        </div>
    );

    const itemTemplate = (inFile: object, uploadProps: any) => {
        const file = inFile as File;

        const handleRemove = () => {
            const updatedAudios = props.audios.filter((a: any) => a.name !== file.name);
            props.setAudios(updatedAudios);

            if (props.setAudioFilesMap) {
                props.setAudioFilesMap((prev: { [key: string]: File }) => {
                    const updated = {...prev};
                    delete updated[file.name];
                    return updated;
                });
            }

            uploadProps.onRemove(file);
        };

        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{width: '80%'}}>
                <span className="flex flex-column text-left ml-3" style={{wordBreak: 'break-all'}}>
                    {file.name}
                </span>
                </div>
                <Button
                    type="button"
                    icon="pi pi-times"
                    className="p-button-outlined p-button-rounded p-button-danger ml-auto"
                    onClick={handleRemove}
                />
            </div>
        );
    };

    const fileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                if (typeof reader.result === 'string') {
                    resolve(reader.result);
                } else {
                    reject(new Error('Failed to convert file to base64'));
                }
            };
            reader.onerror = error => reject(error);
        });
    };

    const handleSaveAudios = async () => {
        const cleanedAudios = await Promise.all(
            props.audios.map(async ({name, src, isActive}: any, index: number) => {
                const file = props.audioFilesMap[name];
                const base64 = file ? await fileToBase64(file) : src;

                return {
                    audioName: name.replace(/\.[^/.]+$/, ""),
                    isActive,
                    audioTempUrl: base64,
                    audioFileName: file?.name || name,
                    fileSize: file?.size,
                    fileType: file?.type,
                    fileLastModified: file?.lastModified,
                    inSystem: false,
                    isHold: false,
                    isRingback: false,
                    order: index + 1,
                };
            })
        );

        const existingAudios = audioData?.audios || [];

        const dedupedExistingAudios = existingAudios.filter((audio: any) =>
            !cleanedAudios.some(
                (newAudio: any) =>
                    newAudio.audioFileName &&
                    (audio.audioFileName === newAudio.audioFileName ||
                        audio.audioName === newAudio.audioName)
            )
        );

        dispatch(setAudioField({
            section: 'audioData',
            fieldName: 'audios',
            value: [
                ...dedupedExistingAudios,
                ...cleanedAudios,
            ]
        }));

        setVisible(false);
    };
    const orderBodyTemplate = (rowdata: any) => {
        return <span>{rowdata.audioId || '-'}</span>;
    }

    const confirmDeleteAudio = (audioId: number | undefined, fileName: string) => {
        confirmDialog({
            message: 'Аудіо буде видалено, продовжити?',
            header: 'Підтвердження',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Так',
            rejectLabel: 'Відмінити',
            accept: () => {
                removeAudio(audioId, fileName);
            },
            reject: () => setAudioToDelete(null)
        });
    };

    const confirmToggleAudioIsActive = (identifier: number, newValue: boolean) => {
        confirmDialog({
            message: newValue ? 'Увімкнути аудіо?' : 'Вимкнути аудіо?',
            header: 'Підтвердження',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Так',
            rejectLabel: 'Відмінити',
            accept: () => toggleAudioIsActive(identifier, newValue)
        });
    };
    return (
        <div className="p-fluid">
            <Toast ref={toast}/>
            <ConfirmDialog style={{minWidth: '200px'}}/>
            <Dialog
                style={{ width: '25vw' }}
                className="mb-4 audio-dialog"
                header="Програвач"
                visible={!!visiblePlayerId}
                onHide={() => {
                    if (currentAudioSrc && currentAudioSrc.startsWith('blob:')) {
                        try {
                            URL.revokeObjectURL(currentAudioSrc);
                        } catch (error) {
                            console.error('Ошибка при очистке blob URL при закрытии диалога:', error);
                        }
                    }
                    setVisiblePlayerId(null);
                    setCurrentAudioSrc(null);
                    setIsPlaying(false);
                    setLastRequestedFileName(null);
                }}
            >
                {currentAudioSrc && (
                    <div className="w-full relative">
                        <AudioPlayerComponent
                            key={visiblePlayerId}
                            src={currentAudioSrc}
                            autoPlay={true}
                            ref={audioPlayerRef}
                            onError={handleAudioError}
                            onPlay={handleAudioPlay}
                            onPause={handleAudioPause}
                            onEnded={handleAudioEnded}
                            onPlayError={(e: any) => {
                                console.error('Ошибка воспроизведения аудио:', e);
                                toast.current?.show({
                                    severity: 'error',
                                    summary: 'Помилка',
                                    detail: 'Помилка відтворення аудіо файлу',
                                    life: 3000
                                });
                            }}
                            showJumpControls={true}
                            preload="metadata"
                        />
                        <Button
                            icon="pi pi-download"
                            onClick={downloadAudioFromUrl}
                            style={{marginLeft: '10px'}}
                            className="absolute outline-none border-none shadow-none border-circle save-mp3 text-lg opacity-100"
                        />
                        <Button
                            icon="pi pi-copy"
                            onClick={() => copyAudioLink(currentAudioSrc)}
                            disabled={currentAudioSrc.startsWith('blob:')}
                            style={{marginLeft: '10px'}}
                            className="absolute outline-none border-none shadow-none border-circle save-mp3 text-lg ml-6 opacity-100"
                        />
                    </div>
                )}
            </Dialog>
            <DataTable
                value={audioData?.audios}
                reorderableRows
                emptyMessage="Немає доступних записів"
                className="mt-3 col-10"
            >
                <Column field="order" body={orderBodyTemplate} header="#" style={{width: '40px'}}/>
                <Column
                    header="Назва файла"
                    body={(rowData) => (
                        <InputText
                            value={rowData.audioName || ''}
                            className="opacity-100 cursor-pointer"
                            disabled
                        />
                    )}
                />
                <Column
                    header="Програвач"
                    bodyClassName={'max-w-5rem'}
                    body={(rowData) => rowData.audioTempUrl ? (
                        <>
                            <Button
                                label="Прослухати"
                                icon="pi pi-play"
                                className="max-w-10rem"
                                onClick={() => {
                                    setPlayRequested(true);
                                    handlePlayAudio(rowData)
                                }}
                            />
                        </>
                    ) : <><Button
                        label="Прослухати"
                        icon="pi pi-play"
                        className="max-w-10rem"
                        loading={loading}
                        onClick={() => {
                            handlePlayAudio(rowData);
                        }}

                    />
                    </>

                    }
                />
                <Column
                    header="Стан"
                    body={(rowData, options) => (
                        <div className="flex align-items-center">
                            <InputSwitch
                                checked={rowData.isActive}
                                onChange={(e) => {
                                    const identifier = rowData.audioId || rowData.order;
                                    confirmToggleAudioIsActive(identifier, e.value);
                                }}
                                disabled={!editType || !archiveTableToggle || !audioData?.isActive}
                            />
                            <label className="ml-4 w-8rem">{rowData.isActive ? 'Активний' : 'Не активний'}</label>
                        </div>
                    )}
                    style={{maxWidth: '120px'}}
                />
                <Column
                    header=""
                    body={(rowData) => (
                        <div className="flex gap-2">
                            <Button
                                icon="pi pi-file-export"
                                className="p-button-secondary"
                                onClick={() => {
                                    setAudioToMove(rowData);
                                    setSelectedTargetGroup(null);
                                    setMoveDialogVisible(true);
                                }}
                                tooltip="Перемістити аудіо файл в групу"
                            />
                            <Button
                                icon="pi pi-times"
                                className="p-button-secondary"
                                onClick={() => {
                                    if (rowData?.audioId) {
                                        confirmDeleteAudio(rowData.audioId, rowData.audioFileName);
                                    } else {
                                        removeAudio(undefined, rowData.audioFileName);
                                    }
                                }}
                            />
                        </div>
                    )}
                    style={{width: '90px'}}
                />
            </DataTable>

            <Divider/>

            <Button label="Додати аудіо" icon="pi pi-upload" className="mt-4 max-w-10rem" onClick={() => setVisible(true)}/>
            {errorFields?.audioFileName && <div className="col-12 md:col-12 pt-2 px-0 pb-0"><span
                className="title p-error text-sm">{errorFields?.audioFileName?.audioFileName}*</span></div>}
            <Dialog header="Завантаження аудіо" visible={visible} style={{width: '30vw'}} onHide={() => setVisible(false)}>
                <FileUpload
                    mode="advanced"
                    name="files[]"
                    // accept="audio/*"
                    accept="audio/mpeg,.mp3"
                    customUpload
                    auto
                    chooseLabel="Завантажити файл"
                    uploadHandler={onFilesSelect}
                    emptyTemplate={emptyTemplate}
                    itemTemplate={itemTemplate}
                    maxFileSize={10485760}
                    multiple
                />
                <div className="flex">
                    <Button
                        label="Відміна"
                        icon="pi pi-ban"
                        onClick={() => setVisible(false)}
                        className="p-button-outlined mt-4 ml-auto mr-2 block"
                    />
                    <Button
                        label="Зберегти та закрити"
                        disabled={!props.audios.length}
                        className="mt-4 block"
                        onClick={handleSaveAudios}
                    />
                </div>
            </Dialog>

            <Dialog
                header="Перемістити аудіо файл в групу"
                visible={moveDialogVisible}
                style={{width: '30vw', maxWidth: '500px'}}
                onHide={() => {
                    setMoveDialogVisible(false);
                    setSelectedTargetGroup(null);
                    setAudioToMove(null);
                }}
            >
                <div key={moveDialogVisible ? 'open' : 'closed'} className="flex flex-column gap-3">
                    <div className="field">
                        <span className="block mb-2">Назва файла</span>
                        <InputText
                            className="opacity-100 w-full"
                            value={(audioToMove?.audioName ?? audioToMove?.audioFileName) ?? ''}
                            disabled
                        />
                    </div>
                    <div className="field">
                        <span className="block mb-2">Групи аудіо</span>
                        <Dropdown
                            value={selectedTargetGroup ?? null}
                            options={(audioGroups || [])
                                .filter((g: any) => g.groupId !== audioData?.groupId)
                                .map((g: any) => ({
                                    label: `${g.groupId} ${g.groupName}`,
                                    value: g.groupId
                                }))}
                            onChange={(e) => setSelectedTargetGroup(e.value)}
                            placeholder="Оберіть групу"
                            filter
                            showClear
                            className="w-full"
                        />
                    </div>
                    <div className="flex justify-content-end mt-3">
                        <Button
                            label="Відміна"
                            icon="pi pi-ban"
                            className="p-button-outlined mr-2"
                            onClick={() => {
                                setMoveDialogVisible(false);
                                setSelectedTargetGroup(null);
                                setAudioToMove(null);
                            }}
                        />
                        <Button
                            label="Зберегти та закрити"
                            disabled={!selectedTargetGroup || !audioToMove?.audioId}
                            onClick={() => {
                                if (audioToMove?.audioId && selectedTargetGroup && audioData?.groupId && jwtToken?.jwtToken) {
                                    dispatch(moveAudioToGroupId(
                                        audioToMove.audioId,
                                        selectedTargetGroup,
                                        jwtToken.jwtToken,
                                        audioData.groupId
                                    ));
                                }
                                setMoveDialogVisible(false);
                                setSelectedTargetGroup(null);
                                setAudioToMove(null);
                            }}
                        />
                    </div>
                </div>
            </Dialog>

        </div>
    );
};

export default AudioFilesComponent;
